<template>
  <SearchYear :title="'Contas da Lamfa'" :minYear="1979" :directory="'contas_lamfa'" />
</template>

<script>
import SearchYear from '@/components/SearchYear.vue';

export default {
  components: {
    SearchYear
  }
};
</script>

<style>
</style>
